(function () {
  document.querySelectorAll('product-info[data-section]').forEach(function (productInfo) {
    var sectionId = productInfo.dataset.section;
    var container = productInfo.closest('[data-cnstrc-product-detail]');
    if (!container) return;

    function updateCnstrcVariant(variant) {
      if (!variant) return;
      container.setAttribute('data-cnstrc-item-variation-id', variant.id);
      var price = variant.compare_at_price
        ? Math.min(variant.price, variant.compare_at_price)
        : variant.price;
      container.setAttribute('data-cnstrc-item-price', (price / 100).toFixed(2));
    }

    function waitAndSubscribe(attempt) {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (event.data && event.data.sectionId === sectionId && event.data.variant) {
            updateCnstrcVariant(event.data.variant);
          }
        });
      } else if (attempt < 120) {
        requestAnimationFrame(function () {
          waitAndSubscribe(attempt + 1);
        });
      }
    }

    waitAndSubscribe(0);
  });
})();
